import React from 'react';
import { BuyAgain, CardCvv, Mobile, Note } from '@one-thd/sui-icons';
import {
  QueryProvider
} from '@thd-nucleus/data-sources';
import { useUserContext } from '../../generic-ui/UserContext';
import { HeaderIconTextButton } from '../../generic-ui/HeaderIconTextButton';
import { headerEvent } from '../../../events/header.events';

const DYNAMIC_QUICK_ACCESS_DICTIONARY = Object.freeze({
  PROJECT: {
    id: 'project',
    label: 'Projects',
    icon: Note,
    pillText: 'NEW',
    redirect: { path: 'projects', url: '/projects' }
  },
});

const headerQuickAccessClasses = 'sui-bg-pro sui-text-inverse sui-hidden lg:sui-flex lg:sui-h-11 sui-pt-3';

const buttonWrapperClasses = 'sui-items-center sui-flex sui-ml-auto sui-mr-4 sui-gap-6';

const helpWrapperClasses = 'sui-items-center sui-flex sui-ml-4 sui-gap-2';

const HeaderB2BQuickAccess = () => {
  const { contactCenter } = useUserContext();
  const projectBenefit = DYNAMIC_QUICK_ACCESS_DICTIONARY.PROJECT;

  const handleOnRedirect = (path, url) => {
    headerEvent.publish({
      eventName: 'header.header-click',
      payload: { clickPath: path?.toLowerCase() }
    });
    window.location.assign(url);
  };

  return (
    <div className={headerQuickAccessClasses} data-testid="header-b2b-quick-access-menu">
      <div className={helpWrapperClasses}>
        <HeaderIconTextButton
          data-testid="header-b2b-need-help"
          label="Need Help?"
          textSize="body-xs"
          textColor="inverse"
          onClick={() => handleOnRedirect('need help', '/c/pro_customer_support')}
          flexDirection="row"
          aria-label="Click to redirect to pro customer support page"
        />

        <HeaderIconTextButton
          data-testid="header-b2b-help-call"
          preamble="Call"
          label={`${contactCenter?.number || '1-866-333-3551'}`}
          textSize="body-xs"
          textColor="inverse"
          icon={Mobile}
          iconSize="small"
          iconColor="inverse"
          flexDirection="row"
          aria-label="Call Home Depot for assistance"
          onClick={() => handleOnRedirect('call', `tel:${contactCenter?.number || '1-866-333-3551'}`)}
        />
        <HeaderIconTextButton
          data-testid="header-b2b-help-text"
          preamble="or Text"
          label={`${contactCenter?.smsNumber || '78465'}`}
          textSize="body-xs"
          textColor="inverse"
          onClick={() => handleOnRedirect('text', `sms:${contactCenter?.smsNumber || '78465'}`)}
          flexDirection="row"
          aria-label="click to text"
        />
      </div>

      <div className={buttonWrapperClasses}>
        <HeaderIconTextButton
          data-testid={`header-b2b-${projectBenefit?.id}`}
          label={projectBenefit?.label}
          textSize="body-xs"
          textColor="inverse"
          onClick={() => handleOnRedirect(projectBenefit?.redirect?.path, projectBenefit?.redirect?.url)}
          icon={projectBenefit.icon}
          pillText={projectBenefit?.pillText}
          iconSize="small"
          iconColor="inverse"
          flexDirection="row"
          aria-label={`Click to redirect to ${projectBenefit?.label} page`}
        />
        <HeaderIconTextButton
          data-testid="header-b2b-buy-it-again"
          label="Buy it Again"
          textSize="body-xs"
          textColor="inverse"
          onClick={() => handleOnRedirect('buy it again', '/buyitagain')}
          icon={BuyAgain}
          iconSize="small"
          iconColor="inverse"
          flexDirection="row"
          aria-label="Click to redirect to buy it again page"
        />
        <HeaderIconTextButton
          data-testid="header-b2b-credit-service"
          label="Home Depot Credit Cards"
          textSize="body-xs"
          onClick={() => handleOnRedirect('Credit Service', '/c/credit-center')}
          icon={CardCvv}
          iconSize="small"
          iconColor="inverse"
          flexDirection="row"
          aria-label="Click to redirect to credit service page"
        />
      </div>
    </div>
  );
};

HeaderB2BQuickAccess.displayName = 'HeaderB2BQuickAccess';

const withQueryProvider = () => () => (
  <QueryProvider cacheKey="hf-pro-quick-access-menus">
    <HeaderB2BQuickAccess />
  </QueryProvider>
);

const QuickAccessWithProvider = withQueryProvider();

export { QuickAccessWithProvider as HeaderB2BQuickAccess };
